  function toggleText() {
    var content = document.querySelector('.expandable-text__content');
    var button = document.querySelector('.expandable-text__toggle');
    if (content.classList.contains('expanded')) {
      content.classList.remove('expanded');
      button.textContent = "Ver más";
    } else {
      content.classList.add('expanded');
      button.textContent = "x Cerrar";
    }
  }
